import React from 'react';
import { CurrencyTotalsTable } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/CurrencyTotalsTable.tsx';
import type { TBankAverageBalanceCurrencyTotals } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/types.ts';
import { formatThousandAmount } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';

interface IAverageBalanceTotalsProps {
  totals: TBankAverageBalanceCurrencyTotals[];
  monthNames: string[];
}

export const AverageBalanceTotals: React.FC<IAverageBalanceTotalsProps> = ({
  totals,
  monthNames,
}) => {
  const monthFields = ['firstMonthAmount', 'secondMonthAmount', 'thirdMonthAmount'] as const;

  return (
    <CurrencyTotalsTable
      ariaLabel="Підсумки середньоденних залишків за валютами"
      headers={['Валюта', ...monthNames.map((month) => `${month}, тис. од.`)]}
      rows={totals.map((total) => ({
        key: total.currency.value,
        values: [
          total.currency.label,
          ...monthFields
            .slice(0, monthNames.length)
            .map((field) => formatThousandAmount(total[field])),
        ],
      }))}
    />
  );
};
